import React from 'react';
import { BounceLoader, BeatLoader } from 'react-spinners';
import style from './style.module.scss';
import './style.css';

const Loading = ({ page }) => {
  const NewLoad = ({size})=>{
    return (
    <div className="load_ss load_ss_m" style={size?{height:size,width:size}:{}}>
      <div className="wall wall-3 wall-color3"></div>
      <div className="wall wall-2 wall-color2"></div>
      <div className="wall wall-1 wall-color1"></div>
      
      <div className="wall wall-4 wall-color1"></div>
      <div className="wall wall-5 wall-color2"></div>
      <div className="wall wall-6 wall-color3"></div>
    </div>
    );
  }

  if (page) {
    return (
      <div className={style.loadingPage}>
        {/* <BeatLoader size={20} color={'#F57B23'} /> */}
        <NewLoad size={100}/>
      </div>
    );
  }

  return (
    <div className={style.loading}>
      {/* <BounceLoader sizeUnit={'px'} size={120} color={'#F57B23'} /> */}
      <NewLoad size={150}/>
    </div> 
  );
};

export default Loading;
